// Copyright 2023, mochabug AB
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true,ts_nocheck=true"
// @generated from file mochabugapis/adapt/plugins/v1/state_contract.proto (package mochabugapis.adapt.plugins.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../../buf/validate/validate_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mochabugapis/adapt/plugins/v1/state_contract.proto.
 */
export const file_mochabugapis_adapt_plugins_v1_state_contract: GenFile = /*@__PURE__*/
  fileDesc("CjJtb2NoYWJ1Z2FwaXMvYWRhcHQvcGx1Z2lucy92MS9zdGF0ZV9jb250cmFjdC5wcm90bxIdbW9jaGFidWdhcGlzLmFkYXB0LnBsdWdpbnMudjEiowEKDVN0YXRlQ29udHJhY3QSOQoKZ2VuZXJhdGlvbhgBIAEoCUIlukgiciAQARhkMhpeW18kYS16QS1aXVtfJGEtekEtWjAtOV0qJBI4CgR3aXBlGAIgASgLMigubW9jaGFidWdhcGlzLmFkYXB0LnBsdWdpbnMudjEuV2lwZVN0YXRlSABCHQoUb25fZ2VuZXJhdGlvbl9jaGFuZ2USBbpIAggBIjcKCVdpcGVTdGF0ZRIfCgZyZWFzb24YASABKAlCCrpIB3IFEAEY+gFIAIgBAUIJCgdfcmVhc29uYgZwcm90bzM", [file_buf_validate_validate]);

/**
 * StateContract describes the compatibility class for opaque plugin-owned
 * state. If a manifest omits a state contract, the platform treats that scope
 * as generation "default". If a StateContract is present, both generation and
 * on_generation_change must be explicit. Generations are author-defined
 * compatibility labels and are not derived from plugin semver.
 *
 * @generated from message mochabugapis.adapt.plugins.v1.StateContract
 */
export type StateContract = Message<"mochabugapis.adapt.plugins.v1.StateContract"> & {
  /**
   * 'generation' identifies the state format compatibility class.
   *
   * @generated from field: string generation = 1;
   */
  generation: string;

  /**
   * 'on_generation_change' is the policy the platform applies when updating
   * from a different generation into this target generation.
   *
   * @generated from oneof mochabugapis.adapt.plugins.v1.StateContract.on_generation_change
   */
  onGenerationChange: {
    /**
     * Wipe the affected state. This is the only supported policy today.
     *
     * @generated from field: mochabugapis.adapt.plugins.v1.WipeState wipe = 2;
     */
    value: WipeState;
    case: "wipe";
  } | { case: undefined; value?: undefined };
};

/**
 * StateContract describes the compatibility class for opaque plugin-owned
 * state. If a manifest omits a state contract, the platform treats that scope
 * as generation "default". If a StateContract is present, both generation and
 * on_generation_change must be explicit. Generations are author-defined
 * compatibility labels and are not derived from plugin semver.
 *
 * @generated from message mochabugapis.adapt.plugins.v1.StateContract
 */
export type StateContractJson = {
  /**
   * 'generation' identifies the state format compatibility class.
   *
   * @generated from field: string generation = 1;
   */
  generation?: string;

  /**
   * Wipe the affected state. This is the only supported policy today.
   *
   * @generated from field: mochabugapis.adapt.plugins.v1.WipeState wipe = 2;
   */
  wipe?: WipeStateJson;
};

/**
 * Describes the message mochabugapis.adapt.plugins.v1.StateContract.
 * Use `create(StateContractSchema)` to create a new message.
 */
export const StateContractSchema: GenMessage<StateContract, {jsonType: StateContractJson}> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_plugins_v1_state_contract, 0);

/**
 * WipeState declares that state should be deleted when entering a generation
 * from any different generation.
 *
 * @generated from message mochabugapis.adapt.plugins.v1.WipeState
 */
export type WipeState = Message<"mochabugapis.adapt.plugins.v1.WipeState"> & {
  /**
   * Optional short reason attached to the wipe decision.
   *
   * @generated from field: optional string reason = 1;
   */
  reason?: string | undefined;
};

/**
 * WipeState declares that state should be deleted when entering a generation
 * from any different generation.
 *
 * @generated from message mochabugapis.adapt.plugins.v1.WipeState
 */
export type WipeStateJson = {
  /**
   * Optional short reason attached to the wipe decision.
   *
   * @generated from field: optional string reason = 1;
   */
  reason?: string;
};

/**
 * Describes the message mochabugapis.adapt.plugins.v1.WipeState.
 * Use `create(WipeStateSchema)` to create a new message.
 */
export const WipeStateSchema: GenMessage<WipeState, {jsonType: WipeStateJson}> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_plugins_v1_state_contract, 1);

